import { configs } from '../configs';
import { Nobles } from '../lib/anuket';
import { streamHook, eventBus } from './Streams';
import { setUpSocket } from './SocketObservable';

/**
 * Get individual ctLive results
 * @param ctliveId
 * @param bib
 * @returns {*}
 */
export function receiveIndividualCtLiveResultByEventAndBib({ ctliveId, bib }) {
  const streamId = `GetIndividualCtLiveResults-${ctliveId}-${bib}`;
  setUpSocket('IndividualResults', `ctl-api/results/${ctliveId}/bib/${bib}`, streamId, configs.shortPollingTime,
    (msg) => {
      eventBus.publish(streamId, msg);
    });

  return streamHook(streamId, { isLoading: true });
}

/**
 * Get individual ctLive results by event and ctentry id
 * @param ctliveId
 * @param ctEntryId
 * @returns {*}
 */
export function receiveIndividualCtLiveResultByEventAndEntry({ ctliveId, ctEntryId }) {
  const streamId = `GetIndividualCtLiveResultsEntry-${ctliveId}-${ctEntryId}`;
  setUpSocket('IndividualResults', `ctl-api/results/${ctliveId}/entry/${ctEntryId}`, streamId, configs.shortPollingTime,
    (msg) => {
      eventBus.publish(streamId, msg);
    });

  return streamHook(streamId, { isLoading: true });
}

/**
 * Get individual ctLive results by event and ctentry id
 * @param affiliateCourseId
 * @param affiliateEventId
 * @param bib
 * @returns {*}
 */
export function receiveIndividualResultByAffiliateIds({ affiliateCourseId, affiliateEventId, bib }) {
  const streamId = `GetIndividualByAffiliateIds-${affiliateCourseId}-${affiliateEventId}-${bib}`;
  const query = affiliateCourseId ? `?race_id=${affiliateCourseId}` : '';
  const path = `ctl-api/results/${affiliateEventId}/bib/${bib}${query}`;

  setUpSocket('IndividualResults', path , streamId, configs.shortPollingTime,
    (msg) => {
      eventBus.publish(streamId, msg);
    });

  return streamHook(streamId, { isLoading: true });
}

export function pullLikesComments(heartedData) {
  if (heartedData.racerId && heartedData.resultEntryId) {
     Nobles.AthletesNoble.isResultHearted(heartedData)
       .subscribe((msg) => eventBus.publish('result-comments-likes', msg));
  }
  else {
    eventBus.publish('result-comments-likes', { Result: { comments: [] } });
  }
}

export function getLikesCommentsStream() {
  return streamHook('result-comments-likes', { isLoading: true });
}

export const IndividualResultsStreams = {
  receiveIndividualCtLiveResultByEventAndBib,
  receiveIndividualCtLiveResultByEventAndEntry,
  receiveIndividualResultByAffiliateIds,
  pullLikesComments,
  getLikesCommentsStream,
};



/** WEBPACK FOOTER **
 ** ./data/IndividualResultsStreams.js
 **/